import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Film, BookOpen, Loader2, AlertTriangle } from "lucide-react";
import { TopNav } from "../components/TopNav";
import { api } from "../lib/api";

const statusLabel = { generating: "Generating…", ready: "Ready", failed: "Failed" };

export default function DashboardPage() {
  const [projects, setProjects] = useState(null);

  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => setProjects([]));
  }, []);

  return (
    <div className="mvp-page" data-testid="dashboard-page">
      <TopNav />
      <main className="mvp-main">
        <div className="mvp-main-head">
          <h1>Your Projects</h1>
          <Link to="/create" className="btn-primary mvp-cta-sm" data-testid="dashboard-new-project-btn">
            <Plus size={16} /> New Project
          </Link>
        </div>

        {projects === null ? (
          <div className="mvp-center"><Loader2 size={28} className="mvp-spin" /></div>
        ) : projects.length === 0 ? (
          <div className="mvp-empty" data-testid="dashboard-empty">
            <Film size={40} />
            <h3>No projects yet</h3>
            <p>Create your first anime or manga project and let the AI build your world.</p>
            <Link to="/create" className="btn-primary mvp-cta-sm" data-testid="empty-create-btn">
              <Plus size={16} /> Create Project
            </Link>
          </div>
        ) : (
          <div className="mvp-grid" data-testid="project-grid">
            {projects.map((p) => (
              <Link key={p.id} to={`/project/${p.id}`} className="mvp-card" data-testid={`project-card-${p.id}`}>
                <div className="mvp-card-cover">
                  {p.cover_image_url ? (
                    <img src={p.cover_image_url} alt={p.title} loading="lazy" />
                  ) : (
                    <div className="mvp-card-cover-ph">
                      {p.type === "anime" ? <Film size={32} /> : <BookOpen size={32} />}
                    </div>
                  )}
                  <span className={`mvp-badge ${p.type}`}>{p.type}</span>
                  <span className={`mvp-status ${p.status}`} data-testid={`project-status-${p.id}`}>
                    {p.status === "generating" && <Loader2 size={12} className="mvp-spin" />}
                    {p.status === "failed" && <AlertTriangle size={12} />}
                    {statusLabel[p.status] || p.status}
                  </span>
                </div>
                <div className="mvp-card-body">
                  <h3>{p.title}</h3>
                  <p>{p.genre}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
